import { z } from "zod";
export const ContactGroupSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(100),
    description: z.string().max(2000).nullable().default(null),
    color: z.string().max(20).nullable().default(null),
    memberCount: z.number().int().nonnegative().default(0),
    createdBy: z.string().email(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ContactGroupCreateSchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(2000).optional(),
    color: z.string().max(20).optional(),
});
export const ContactGroupUpdateSchema = ContactGroupCreateSchema.partial();
export const ContactGroupAddMembersSchema = z.object({
    contactIds: z.array(z.string().uuid()).min(1).max(500),
});
export const ContactGroupListResponseSchema = z.object({
    groups: z.array(ContactGroupSchema),
    total: z.number().int(),
});
//# sourceMappingURL=contact-groups.js.map